import './App.css';
import MatrixList from '../MatrixList/MatrixList';
import SignInForum from '../SignIn/SignInForum';
import {RequestAccount, RequestSubmitted} from '../SignIn/RequestAccount';
import CreateAccount from '../SignIn/CreateAccount';
import Home from '../Home/home';
import NavBar from './NavBar';
import CalendarPage from '../Calendar/CalendarPage';
import AdminPage from '../Admin/AdminPage';
import PageNotFound from '../ErrorPages/404';
import ReservationViewer from '../Reservation/ReservationViewer';
import MatricesPrivacyPolicyPage from '../Matrices/MatricesPrivacyPolicyPage';
import MatricesTermsOfServicePage from '../Matrices/MatricesTermsOfServicePage';

import navBarStyles from './nav-bar-style.module.css';

import { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import ContactPage from '../Contact/ContactPage';
import AccountSettings from '../Account/AccountSettings';
import Housekeeping from '../Housekeeping/Housekeeping';
import CheckInOutForm, { CIOFormSubmitted } from '../Housekeeping/CheckInOutForm';
import GuestCheckIn, { GuestPaid } from '../Guest/GuestCheckIn';

function App() {
	const [showNavBar, setShowNavBar] = useState(false);
	const [profileDropdownVisible, setProfileDropdownVisible] = useState(false);

	const root = document.getElementById('root');
	root.onclick = (e) => {
		const dropdown = document.getElementById(navBarStyles.profile_dropdown);
		const profilePic = document.getElementById('nav_bar_profile_pic');
		if(!dropdown?.contains(e.target) && !profilePic?.contains(e.target))
            setProfileDropdownVisible(false);
	}

	return (
		
		<BrowserRouter>
			{showNavBar ? <NavBar 	profileDropdownVisible={profileDropdownVisible} 
									setProfileDropdownVisible={setProfileDropdownVisible}/> : null}
			
			<Routes>
				<Route path='/'       			element={<PrivateRoute requiredPermission="view-home" path='/home'> <Home setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/home'   			element={<PrivateRoute requiredPermission="view-home" path='/home'> <Home setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/account-settings' element={<PrivateRoute requiredPermission="view-home" path='/account-settings'> <AccountSettings setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
	
				<Route path='/admin'   			element={<PrivateRoute requiredPermission="is-admin" path='/admin'> <AdminPage setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/calendar' 		element={<PrivateRoute requiredPermission="view-all-events" path='/admin'> <CalendarPage setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/reservation/:id'  element={<PrivateRoute requiredPermission="view-all-events" path='/admin'> <ReservationViewer setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/matrix-list'	 	element={<PrivateRoute requiredPermission="view-all-events" path='/admin'> <MatrixList setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>

				<Route path='/housekeeping' 		element={<PrivateRoute requiredPermission="view-home" path='/housekeeping'> <Housekeeping setShowNavBar={setShowNavBar}/> </PrivateRoute>}></Route>
				<Route path='/check-in-out-form' 			element={<CheckInOutForm setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/check-in-out-form/submitted' element={<CIOFormSubmitted setShowNavBar={setShowNavBar}/>}></Route>

				<Route path='/signin' 			element={<SignInForum setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/request-account'	element={<RequestAccount setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/request-submitted'	element={<RequestSubmitted setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/create-account/:id'	element={<CreateAccount setShowNavBar={setShowNavBar}/>}></Route>

				<Route path='/guest/check-in'					element={<GuestCheckIn setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/guest/check-in/payment-complete'	element={<GuestPaid setShowNavBar={setShowNavBar}/>}></Route>
				
				

				<Route path='/matrices/privacy-policy' 	 element={<MatricesPrivacyPolicyPage  setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/matrices/terms-of-service' element={<MatricesTermsOfServicePage setShowNavBar={setShowNavBar}/>}></Route>
				<Route path='/contact'          element={<ContactPage setShowNavBar={setShowNavBar}/>}></Route>

				<Route path='*' 			element={<PageNotFound setShowNavBar={setShowNavBar}/>}></Route>
			</Routes>
			
		</BrowserRouter>
	);
}

export default App;
